<template>
  <div>
    <!-- header  -->
    <section
      :class="
        userData.isAndroid
          ? 'padding-nevigate-bar-ANDROID'
          : 'padding-nevigate-bar-IOS'
      "
      v-if="userData.channel != 'WEB'"
    >
      <div class="row no-gutters">
        <div class="col-2 pl-2 justify-content-center align-self-center">
          <div @click="goToPreviousPage()">
            <b-icon
              class="text-kanit-color-black"
              icon="chevron-left"
              style="width: 24px; height: 24px"
            />
          </div>
        </div>
        <div class="col-8 justify-content-center align-self-center">
          <div class="mx-0 text-center font-kanit-bold-20">
            {{ this.currentMenu.pageName }}
          </div>
        </div>
        <div class="col-2 px-0"></div>
      </div>
    </section>
    <div
      :class="
        userData.isAndroid
          ? 'justify-content-md-center d-flex flex-column justify-content-between h-100 p-3'
          : ' d-flex flex-column justify-content-between h-100 p-3'
      "
      style="height: 95vh !important"
    >
      <div>
        <!-- Card Infomation -->
        <div
          class="pt-4"
          id="card-infomation"
          style="display: block; margin-top: 16px"
        >
          <span
            class="font-kanit-regular-16 text-kanit-color-grey"
            style="display: block"
            >สามารถใช้ Statement จากหลายบัญชีประกอบกัน
          </span>
          <span
            class="font-kanit-regular-16 text-kanit-color-grey"
            style="display: block"
            >เพื่อให้ครบ {{ ktbStatementCalc }}</span
          >
          <div class="w-100 border-top-NEXT my-3" />
        </div>

        <!-- Document Required -->
        <div id="card-document-list">
          <div>
            <span class="font-kanit-bold-16">Statement จากบัญชีหลัก</span>
          </div>
          <div class="mb-3">
            <span
              class="font-kanit-regular-16 text-kanit-color-grey"
              style="display: block"
              >ควรใช้บัญชีที่มีรายการเคลื่อนไหวอย่างสม่ำเสมอ
            </span>
          </div>

          <div class="mb-4 justify-content-md-center">
            <b-card
              class="border-radius-1rem"
              body-class="body-landing py-3"
              @click="goTo('mainAccount', mainAccountTitle)"
            >
              <b-row style="line-height: 32px">
                <b-col cols="1" align-self="center">
                  <template
                    v-if="
                      mainAccountFiles.length == 0 && !errorMainAccountFiles
                    "
                  >
                    <b-badge pill class="badge-wait"
                      ><span
                        class="font-kanit-bold-16"
                        style="line-height: 32px"
                      >
                        1
                      </span></b-badge
                    >
                  </template>
                  <template
                    v-else-if="
                      mainAccountFiles.length > 0 &&
                      !errorMainAccountFiles &&
                      !successMainAccountFiles
                    "
                  >
                  <b-img
                      center
                      :src="iconUploadated"
                      width="32"
                      height="32"
                    ></b-img>
                  </template>
                  <template v-else-if="errorMainAccountFiles">
                    <b-img
                      center
                      :src="iconUploadsError"
                      width="32"
                      height="32"
                    ></b-img>
                  </template>
                  <template v-else-if="successMainAccountFiles">
                    <b-img
                      center
                      :src="iconUploadsSuccess"
                      width="32"
                      height="32"
                    ></b-img>
                  </template>
                </b-col>
                <b-col
                  class="px-0 text-left"
                  col
                  style="padding-left: 34px !important"
                >
                  <b-row>
                    <b-col
                      style="line-height: 1"
                      col
                      :class="
                        mainAccountFiles.length == 0 ? 'title-without-file' : ''
                      "
                    >
                      <span
                        class="font-kanit-regular-16 text-kanit-color-black"
                        >{{ mainAccountTitle }}</span
                      >
                    </b-col>
                  </b-row>
                  <div class="w-100" />

                  <!-- resubmit -->
                  <b-row
                    v-if="
                      mainAccountFiles.length == 0 &&
                      'RESUBMIT' == userData.followupStatus.code &&
                      getHistoryUploads('mainAccount')
                    "
                  >
                    <b-col style="line-height: 1" col>
                      <span
                        class="font-kanit-regular-14 text-kanit-color-orange"
                        >ขอเอกสารเพิ่มเติม</span
                      >
                    </b-col>
                  </b-row>
                  <b-row v-else-if="mainAccountFiles.length > 0">
                    <b-col style="line-height: 1" col>
                      <span
                        v-if="
                          !errorMainAccountFiles &&
                          !successMainAccountFiles &&
                          'RESUBMIT' !== userData.followupStatus.code
                        "
                        class="font-kanit-regular-14 text-kanit-color-blue"
                        >มี {{ mainAccountFiles.length }} เอกสารแนบ</span
                      >
                      <span
                        v-if="
                          !errorMainAccountFiles &&
                          !successMainAccountFiles &&
                          'RESUBMIT' == userData.followupStatus.code
                        "
                        class="font-kanit-regular-14 text-kanit-color-blue"
                      >
                        แนบเอกสารแล้ว รอกดอัปโหลด</span
                      >
                      <span
                        v-else-if="errorMainAccountFiles"
                        class="font-kanit-regular-14 text-kanit-color-danger"
                        >อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง</span
                      >
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  cols="1"
                  class="px-0"
                  align-self="center"
                  style="line-height: 32px; padding-right: 32px !important"
                >
                  <b-icon
                    icon="chevron-right"
                    font-scale="1.3"
                    style="color: #838383; margin-bottom: 25%"
                  />
                </b-col>
              </b-row>
            </b-card>
          </div>
        </div>

        <!-- Document Optional -->
        <div id="card-document-list">
          <div>
            <span class="font-kanit-bold-16"
              >Statement จากบัญชีเพิ่มเติม (ถ้ามี)</span
            >
          </div>
          <div class="mb-3">
            <span
              class="font-kanit-regular-16 text-kanit-color-grey"
              style="display: block"
            >
              สามารถเพิ่มบัญชีจากธนาคารเดิมหรือธนาคารอื่นได้
            </span>
            <span class="font-kanit-regular-16 text-kanit-color-grey"
              >อีก 2 บัญชีเพื่อให้ข้อมูลครบถ้วน</span
            >
          </div>

          <div class="mb-3 justify-content-md-center">
            <b-card
              class="border-radius-1rem"
              body-class="body-landing py-3"
              @click="goTo('additionalAccount1', additionalAccountTitle)"
            >
              <b-row style="line-height: 32px">
                <b-col cols="1" align-self="center">
                  <template
                    v-if="
                      additionalAccount1Files.length == 0 &&
                      !errorAdditionalAccount1Files
                    "
                  >
                    <b-badge pill class="badge-wait"
                      ><span
                        class="font-kanit-bold-16"
                        style="line-height: 32px"
                      >
                        2
                      </span></b-badge
                    >
                  </template>
                  <template
                    v-else-if="
                      additionalAccount1Files.length > 0 &&
                      !errorAdditionalAccount1Files &&
                      !successAdditionalAccount1Files
                    "
                  >
                  <b-img
                      center
                      :src="iconUploadated"
                      width="32"
                      height="32"
                    ></b-img>
                  </template>
                  <template v-else-if="errorAdditionalAccount1Files">
                    <b-img
                      center
                      :src="iconUploadsError"
                      width="32"
                      height="32"
                    ></b-img>
                  </template>
                  <template v-else-if="successAdditionalAccount1Files">
                    <b-img
                      center
                      :src="iconUploadsSuccess"
                      width="32"
                      height="32"
                    ></b-img>
                  </template>
                </b-col>
                <b-col
                  class="px-0 text-left"
                  col
                  style="padding-left: 34px !important"
                >
                  <b-row>
                    <b-col
                      style="line-height: 1"
                      col
                      :class="
                        additionalAccount1Files.length == 0
                          ? 'title-without-file'
                          : ''
                      "
                    >
                      <span
                        class="font-kanit-regular-16 text-kanit-color-black"
                        >{{ additionalAccountTitle }}</span
                      >
                    </b-col>
                  </b-row>
                  <!-- resubmit -->
                  <b-row
                    v-if="
                      additionalAccount1Files.length == 0 &&
                      'RESUBMIT' == userData.followupStatus.code &&
                      getHistoryUploads('additionalAccount1')
                    "
                  >
                    <b-col style="line-height: 1" col>
                      <span
                        class="font-kanit-regular-14 text-kanit-color-orange"
                        >ขอเอกสารเพิ่มเติม</span
                      >
                    </b-col>
                  </b-row>
                  <b-row v-else-if="additionalAccount1Files.length > 0">
                    <b-col style="line-height: 1" col>
                      <span
                        v-if="
                          !errorAdditionalAccount1Files &&
                          !successAdditionalAccount1Files &&
                          'RESUBMIT' !== userData.followupStatus.code
                        "
                        class="font-kanit-regular-14 text-kanit-color-blue"
                        >มี {{ additionalAccount1Files.length }} เอกสารแนบ</span
                      >
                      <span
                        v-if="
                          !errorAdditionalAccount1Files &&
                          !successAdditionalAccount1Files &&
                          'RESUBMIT' == userData.followupStatus.code
                        "
                        class="font-kanit-regular-14 text-kanit-color-blue"
                      >
                        แนบเอกสารแล้ว รอกดอัปโหลด</span
                      >
                      <span
                        v-else-if="errorAdditionalAccount1Files"
                        class="font-kanit-regular-14 text-kanit-color-danger"
                        >อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง</span
                      >
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  cols="1"
                  class="px-0"
                  align-self="center"
                  style="line-height: 32px; padding-right: 32px !important"
                >
                  <b-icon
                    icon="chevron-right"
                    font-scale="1.3"
                    style="color: #838383; margin-bottom: 25%"
                  />
                </b-col>
              </b-row>
            </b-card>
          </div>
          <div class="mb-4 justify-content-md-center">
            <b-card
              class="border-radius-1rem"
              body-class="body-landing py-3"
              @click="goTo('additionalAccount2', additionalAccountTitle)"
            >
              <b-row style="line-height: 32px">
                <b-col cols="1" align-self="center">
                  <template
                    v-if="
                      additionalAccount2Files.length == 0 &&
                      !errorAdditionalAccount2Files
                    "
                  >
                    <b-badge pill class="badge-wait"
                      ><span
                        class="font-kanit-bold-16"
                        style="line-height: 32px"
                      >
                        3
                      </span></b-badge
                    >
                  </template>
                  <template
                    v-else-if="
                      additionalAccount2Files.length > 0 &&
                      !errorAdditionalAccount2Files &&
                      !successAdditionalAccount2Files
                    "
                  >
                  <b-img
                      center
                      :src="iconUploadated"
                      width="32"
                      height="32"
                    ></b-img>
                  </template>
                  <template v-else-if="errorAdditionalAccount2Files">
                    <b-img
                      center
                      :src="iconUploadsError"
                      width="32"
                      height="32"
                    ></b-img>
                  </template>
                  <template v-else-if="successAdditionalAccount2Files">
                    <b-img
                      center
                      :src="iconUploadsSuccess"
                      width="32"
                      height="32"
                    ></b-img>
                  </template>
                </b-col>
                <b-col
                  class="px-0 text-left"
                  col
                  style="padding-left: 34px !important"
                >
                  <b-row>
                    <b-col
                      style="line-height: 1"
                      col
                      :class="
                        additionalAccount2Files.length == 0
                          ? 'title-without-file'
                          : ''
                      "
                    >
                      <span
                        class="font-kanit-regular-16 text-kanit-color-black"
                        >{{ additionalAccountTitle }}</span
                      >
                    </b-col>
                  </b-row>
                  <!-- resubmit -->
                  <b-row
                    v-if="
                      additionalAccount2Files.length == 0 &&
                      'RESUBMIT' == userData.followupStatus.code &&
                      getHistoryUploads('additionalAccount2')
                    "
                  >
                    <b-col style="line-height: 1" col>
                      <span
                        class="font-kanit-regular-14 text-kanit-color-orange"
                        >ขอเอกสารเพิ่มเติม</span
                      >
                    </b-col>
                  </b-row>

                  <b-row v-else-if="additionalAccount2Files.length > 0">
                    <b-col style="line-height: 1" col>
                      <span
                        v-if="
                          !errorAdditionalAccount2Files &&
                          !successAdditionalAccount2Files &&
                          'RESUBMIT' !== userData.followupStatus.code
                        "
                        class="font-kanit-regular-14 text-kanit-color-blue"
                        >มี {{ additionalAccount2Files.length }} เอกสารแนบ</span
                      >
                      <span
                        v-if="
                          !errorAdditionalAccount2Files &&
                          !successAdditionalAccount2Files &&
                          'RESUBMIT' == userData.followupStatus.code
                        "
                        class="font-kanit-regular-14 text-kanit-color-blue"
                      >
                        แนบเอกสารแล้ว รอกดอัปโหลด</span
                      >
                      <span
                        v-else-if="errorAdditionalAccount2Files"
                        class="font-kanit-regular-14 text-kanit-color-danger"
                        >อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง</span
                      >
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  cols="1"
                  class="px-0"
                  align-self="center"
                  style="line-height: 32px; padding-right: 32px !important"
                >
                  <b-icon
                    icon="chevron-right"
                    font-scale="1.3"
                    style="color: #838383; margin-bottom: 25%"
                  />
                </b-col>
              </b-row>
            </b-card>
          </div>
        </div>
        <div class="text-kanit-color-grey font-kanit-regular-14 text-center">
          แนบเอกสารจากทุกบัญชีรวมกันได้สูงสุด 20 MB
        </div>
        <div class="pt-2">
          <b-progress
            :value="getAllSize()"
            :variant="getColorProgress()"
            :max="maxsize"
            class="mb-2 progress-upload-custom"
          ></b-progress>
        </div>
        <b-row class="size-memory py-1 text-center">
          <b-col>
            <span class="font-kanit-regular-14 text-kanit-color-grey"
              >ใช้ไปแล้ว
            </span>
            <span
              :class="!checkLimit() ? 'text-kanit-color-danger' : ''"
              class="font-kanit-regular-14 text-kanit-color-grey"
              >{{ getAllSize() + "/" + maxsize }}</span
            >
            <span class="font-kanit-regular-14 text-kanit-color-grey">
              MB
            </span></b-col
          >
        </b-row>
      </div>

      <!-- Button -->
      <div class="mt-3">
        <b-row v-if="!this.checkDocIsSuccess()">
          <b-col align-self="center">
            <button
              @click="goStatementDocument()"
              :disabled="
                realFiles.length == 0 ||
                realFiles.filter((file) => file.state == 'error').length > 0
              "
              class="btn btn-block btn-submit-landing-page"
              style="letter-spacing: 0px"
            >
              ถัดไป
            </button>
          </b-col>
        </b-row>
      </div>
    </div>

    <b-modal
      v-model="modalShowBackStep"
      hide-header
      hide-header-close
      hide-footer
      content-class="content-dialog-back"
    >
      <div class="justify-content-center py-4">
        <b-row>
          <b-col style="text-align: center"
            ><span class="font-kanit-bold-20 text-kanit-color-black"
              >ยืนยันการออกจากหน้านี้?</span
            ></b-col
          >
        </b-row>
        <b-row class="pt-2">
          <b-col style="text-align: center">
            <span class="font-kanit-regular-16 text-kanit-color-black"
              >เอกสารที่เลือกไว้จะไม่ถูกบันทึก</span
            ></b-col
          >
        </b-row>

        <b-row class="pt-4">
          <b-col cols="6">
            <b-button
              class="btn-block btn btn-info btn-ktb-cancel btn-cancel-file-duplication"
              @click="closeModalShowBackStep()"
            >
              <span class="">ยกเลิก</span>
            </b-button>
          </b-col>

          <b-col cols="6">
            <b-button
              class="btn-block btn btn-info btn-confirm-file-duplication"
              @click="backPage()"
            >
              <span class="">ออกจากหน้านี้</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgSwalErr: require("@/assets/images/ic_swal_error_reject.png"),
      imgArrowRight: require("@/assets/images/ic_landing_nevigate.png"),
      iconUploadsError: require("@/assets/images/ic_landing_error.png"),
      iconUploadsSuccess: require("@/assets/images/ic_landing_success.png"),
      iconUploading: require("@/assets/images/foundationIconSimpleComponentSnackbarUpload.png"),
      iconUploadated: require("@/assets/images/ic_landing_uploaded.png"),
      imgArrowNone: require("@/assets/images/ic_landing_nevigate.png"),
      iconExpireDate: require("@/assets/images/ic_pending.png"),
      isUploadedFiles: require("@/assets/images/iconSelectUpload.png"),
      documentGroup: {},
      axiosInstance: null,
      timeout: parseInt(process.env.VUE_APP_TIMEOUT),
      maxsize: parseInt(process.env.VUE_APP_MAXSIZE),
      user: {},
      isUpload: false,
      updateRender: 1,
      countDocTypeUploading: 0,
      countDocTypeAttachfile: 0,
      urlapi: process.env.VUE_APP_APIURL,
      groupRequire: [],
      groupDeviate: [],
      docList: [],
      modalShow: false,
      errorDialogTitle: "",
      errorDialogMessage: "",
      errorDialogHeader: "",
      errorDialogImage: null,
      currentMenu: null,
      statementGroupId: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT,
      mainAccountFiles: [],
      additionalAccount1Files: [],
      additionalAccount2Files: [],
      realFiles: [],
      ktbStatementCalc: "",
      documentTypeGroup: [],
      modalShowBackStep: false,
      mainAccountTitle: "บัญชีหลัก",
      additionalAccountTitle: "บัญชีเพิ่มเติม (ถ้ามี)",
      errorMainAccountFiles: false,
      errorAdditionalAccount1Files: false,
      errorAdditionalAccount2Files: false,
      successMainAccountFiles: false,
      successAdditionalAccount1Files: false,
      successAdditionalAccount2Files: false,
      otherBankHistory: [],
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    getHeight() {
      return window.innerHeight - 45;
    },
  },
  mounted() {
    this.$store.dispatch("setUserData", this.userData);

    window.onMobileBackPressed = function () {
      console.log("onMobileBackPressed");
      this.goToPreviousPage();
      return true;
    };
  },
  created() {
    this.documentTypeGroup = this.userData.document_group_type.find(
      (v) => v.grp_id == this.statementGroupId
    );
    const documentType = this.userData.documentType.find(
      (v) => v.doc_code == this.documentTypeGroup.lst_doc_id[0]
    );
    this.realFiles = documentType.filesReal;
    this.ktbStatementCalc = this.userData.periodStatementOtherBanks;
    this.otherBankHistory = this.userData.otherBankHistory;
    this.mainAccountFiles = documentType.filesReal?.filter(
      (file) => file.uploadType == "mainAccount"
    );

    this.additionalAccount1Files = documentType.filesReal?.filter(
      (file) => file.uploadType == "additionalAccount1"
    );

    this.additionalAccount2Files = documentType.filesReal?.filter(
      (file) => file.uploadType == "additionalAccount2"
    );

    this.realFiles.forEach((file) => {
      switch (file.uploadType) {
        case "mainAccount":
          if (file.state == "error") {
            this.errorMainAccountFiles = true;
          } else if (file.state == "success") {
            this.successMainAccountFiles = true;
          }
          break;

        case "additionalAccount1":
          if (file.state == "error") {
            this.errorAdditionalAccount1Files = true;
          } else if (file.state == "success") {
            this.successAdditionalAccount1Files = true;
          }
          break;

        case "additionalAccount2":
          if (file.state == "error") {
            this.errorAdditionalAccount2Files = true;
          } else if (file.state == "success") {
            this.successAdditionalAccount2Files = true;
          }
          break;
      }

      // if (
      //   file.state &&
      //   file.state == "error" &&
      //   file.uploadType == "mainAccount"
      // ) {
      //   this.errorMainAccountFiles = true;
      // }
      // if (
      //   file.state &&
      //   file.state == "error" &&
      //   file.uploadType == "additionalAccount1"
      // ) {
      //   this.errorAdditionalAccount1Files = true;
      // }
      // if (
      //   file.state &&
      //   file.state == "error" &&
      //   file.uploadType == "additionalAccount2"
      // ) {
      //   this.errorAdditionalAccount2Files = true;
      // }
    });

    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      //console.error(err);
    }
    this.currentMenu = {
      pageCode: "CommonUploadOtherBanks",
      pageName: "แนบ Statement ด้วยตนเอง",
      previousPage: this.userData.routerPath.documentGroup,
      params: { grpId: this.userData.grpId },
      isShow: true,
    };
    this.$event.$emit("update_current_menu", this.currentMenu);

    window.onMobileBackPressed = function () {
      console.log("onMobileBackPressed");

      this.$callback.openLfmStatusPage();

      return true;
    };
  },
  methods: {
    goToPreviousPage() {
      if (this.checkDocIsSuccess()) {
        this.$router.push({
          name: this.currentMenu.previousPage,
        });
        return;
      } else {
        if (
          this.realFiles.length == 0 &&
          this.userData.documentType.find(
            (v) => v.doc_code == this.documentTypeGroup.lst_doc_id[0]
          ).filesReal.length == 0
        ) {
          this.goback();
          return;
        } else {
          this.modalShowBackStep = true;
        }
      }
    },
    goback() {
      this.$router.push({
        name: this.userData.routerPath.documentGroup,
        params: { grpId: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT },
      });
    },
    goTo(uploadType, accountTitle) {
      const titleSplit = accountTitle.split(" (");

      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      this.$router.push({
        name: this.userData.routerPath.uploadOtherBank,
        params: {
          doc_code: document_group_type.lst_doc_id[0],
          grpId: this.grpId,
          uploadType: uploadType,
          accountTitle: titleSplit[0],
        },
      });
    },
    checkLimit() {
      if (this.getAllSize() > this.maxsize) {
        return false;
      }
      return true;
    },
    getAllSize() {
      let bytes = 0;
      this.realFiles.forEach((i) => {
        bytes = bytes + i.filesize;
      });
      return (bytes / (1024 * 1024)).toFixed(1);
    },
    getColorProgress() {
      if (this.getAllSize() > this.max) {
        return "danger";
      }
      return "";
    },
    checkDocIsSuccess() {
      const data = this.userData.documentType.find(
        (v) => v.doc_code == this.documentTypeGroup.lst_doc_id[0]
      );
      return data.state != undefined && data.state == "success";
    },
    closeModalShowBackStep() {
      this.modalShowBackStep = false;
    },
    backPage() {
      this.userData.documentType.find(
        (v) => v.doc_code == this.documentTypeGroup.lst_doc_id[0]
      ).filesReal = [];

      this.userData.documentType.find(
        (v) => v.doc_code == this.documentTypeGroup.lst_doc_id[0]
      ).state = "wait";

      this.userData.document_group_type.find(
        (i) => i.grp_id == this.statementGroupId
      ).state = "wait";

      let param = this.currentMenu.params;
      if (param != undefined && param.grpId != undefined) {
        this.$router.push({
          name: this.currentMenu.previousPage,
          params: { grpId: param.grpId },
        });
      }
    },
    goStatementDocument() {
      const documentType = this.userData.documentType.find(
        (v) => v.doc_code == this.documentTypeGroup.lst_doc_id[0]
      );
      this.$set(documentType, "state", "attachfile");
      this.$router.push({
        name: this.userData.routerPath.documentGroup,
        params: { grpId: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT },
      });
    },
    getHistoryUploads(accountType) {
      let history = this.userData.otherBankHistory.find(
        (i) => i == accountType
      );
      return history !== null && history !== undefined;
    },
  },
};
</script>
<style scoped>
.row-card-landing {
  padding-left: 14px;
  padding-right: 14px;
}

.body-landing {
  padding-left: 1rem;
  padding-right: 1rem;
}

.progress-bar-custom {
  height: 3px;
  border-radius: unset;
  border-bottom-left-radius: 60px 27px;
  border-bottom-right-radius: 60px 27px;
  margin-left: 2.5px;
  margin-right: 2.5px;
  background-color: unset;
}

.status-color-001 {
  color: #479e6a !important;
}

.status-color-002 {
  color: #df0747 !important;
}

.status-color-003,
.status-color-004 {
  color: #daa60b !important;
}

.status-color-PENDING,
.status-color-RESUBMIT {
  color: #df0747 !important;
}

.status-color-SUBMITED,
.status-color-SUBMITED2,
.status-color-COMPLETE {
  color: #479e6a !important;
}

.badge-wait {
  border: 1.5px solid #f8f8f8 !important;
  box-sizing: border-box;
  color: #cacaca !important;
  background-color: #f8f8f8;
  width: 32px;
  height: 32px;
  margin-left: 1%;
}
.badge-wait-primary {
  border: 1.5px solid #e0e9fa !important;
  box-sizing: border-box;
  color: #e0e9fa !important;
  background-color: #e0e9fa;
  width: 32px;
  height: 32px;
  margin-left: 1%;
}
.text-danger {
  color: rgb(219, 0, 0);
  font-family: KrungthaiFast-Regular, Arial, sans-serif !important;
  font-size: 16px !important;
}

.text-resubmit {
  color: rgb(212, 150, 74);
  font-family: KrungthaiFast-Regular, Arial, sans-serif !important;
  font-size: 16px !important;
}
</style>
<style>
.text-loan-info {
  color: black !important;
  font-family: KrungthaiFast-Bold, Arial, sans-serif !important;
}

.text-label {
  color: #727a8d !important;
  font-size: 14px;
}

.position-footer {
  position: fixed;
  bottom: 0;
  margin-bottom: 10%;
}

.content-card-sm {
  min-height: 45vh;
}

.content-card-md {
  min-height: 55vh;
}

.btn-loading {
  color: rgb(145, 159, 169) !important;
  background-color: rgb(231, 235, 240) !important;
  border-color: rgb(231, 235, 240) !important;
  background-image: none !important;
}

.swal2-htmlContainer-next-fullscreen {
  font-size: 16px !important;
  margin-bottom: 40vh !important;
  margin-top: 1rem !important;
  line-height: 24px !important;
  height: 50% !important;
}

.swal2-image-next-fullscreen {
  margin-top: 0vh !important;
  margin-bottom: 0vh !important;
}

.swal2-icon {
  border-color: unset !important;
  border: unset !important;
  line-height: 20px !important;
  width: 100% !important;
  margin: 0px !important;
  align-items: unset !important;
}

.swal2-icon-content {
  margin: 0;
  font-family: Kanit-Bold;
  font-size: 20px !important;
  line-height: 24px !important;
  color: #212121 !important;
}

.swal2-modal-next-fullscreen {
  border-radius: 0px !important;
  width: 100% !important;
  padding: 24px !important;
  height: 100vh !important;
  -webkit-animation: unset !important;
  animation: unset !important;
}

.swal2-actions-next-fullscreen {
  display: flex !important;
  justify-content: center !important;
  margin-top: 1rem !important;
  margin-right: 0px !important;
  margin-bottom: 35px !important;
  margin-left: 0px !important;
}

.expired-date-css {
  border-radius: 33px;
  background: rgba(254, 238, 227, 1);
  color: #e17f00 !important;
  font-size: 14px !important;
  line-height: 16px !important;
}
</style>
<style scoped>
.swal2-html-container {
  margin: 1em 1.6em 40vh !important;
}

.icon-loader {
  border: 1px solid rgba(242, 242, 242, 1);
  /* Light grey */
  border-top: 1px solid rgba(68, 87, 227, 1);
  /* Blue */
  border-radius: 50%;
  width: 32px;
  height: 32px;
  animation: spin 1s linear infinite;
  position: absolute;
}

.border-top-NEXT {
  border-top: 1px solid #e0e0e0 !important;
}

.horizontal-devider {
  height: 6px;
  background: #f8f8f8;
  border-radius: 3px;
}

.title-without-file {
  position: relative;
  top: 3px;
}

.progress-upload-custom {
  height: 0.4rem !important;
  width: 100%;
  background-color: #f8f8f8 !important;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
